import React, { useEffect, useMemo, useState } from 'react';

const ExportColumnModal = ({
    modalId,
    title = 'Export Columns',
    columns = [],
    onExport,
    isExporting = false,
}) => {
    const defaultKeys = useMemo(() => columns.map((column) => column.key), [columns]);
    const [selectedKeys, setSelectedKeys] = useState(defaultKeys);

    useEffect(() => {
        setSelectedKeys(defaultKeys);
    }, [defaultKeys]);

    const selectedColumns = columns.filter((column) => selectedKeys.includes(column.key));

    const toggleColumn = (key) => {
        setSelectedKeys((prev) => (
            prev.includes(key)
                ? prev.filter((item) => item !== key)
                : [...prev, key]
        ));
    };

    const hideModal = () => {
        const modalElement = document.getElementById(modalId);
        if (!modalElement || !window.bootstrap?.Modal) return;

        const modal = window.bootstrap.Modal.getInstance(modalElement)
            || new window.bootstrap.Modal(modalElement);
        modal.hide();
    };

    const handleExport = async () => {
        if (!selectedColumns.length || isExporting) return;
        await onExport(selectedColumns);
        hideModal();
    };

    return (
        <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby={`${modalId}-label`} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id={`${modalId}-label`}>{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <span className="text-muted small">{selectedColumns.length} of {columns.length} columns selected</span>
                            <div>
                                <button type="button" className="btn btn-link btn-sm px-2" onClick={() => setSelectedKeys(defaultKeys)}>
                                    Select all
                                </button>
                                <button type="button" className="btn btn-link btn-sm px-2" onClick={() => setSelectedKeys([])}>
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            {columns.map((column) => (
                                <div className="col-md-6 mb-2" key={column.key}>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`${modalId}-${column.key}`}
                                            checked={selectedKeys.includes(column.key)}
                                            onChange={() => toggleColumn(column.key)}
                                        />
                                        <label className="form-check-label" htmlFor={`${modalId}-${column.key}`}>
                                            {column.label}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleExport}
                            disabled={!selectedColumns.length || isExporting}
                        >
                            {isExporting ? 'Exporting...' : 'Export Excel'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExportColumnModal;
